export default __webpack_public_path__ + "static/media/ChatBotIcon.01eccb44.svg";